export class IncomeCategory {
  constructor() {
    this.id = null;
    this.name = '';
    this.code = '';

    this.is_active = false;
  }
}
